module.exports = __webpack_public_path__ + "static/media/Book.7c6312ef.mp4";